import { useCallback } from 'react';
import { useLocation, useParams } from 'react-router';

import metatitle from 'Utilities/metatitle';

import { BlogParams, WordpressData } from '../@types/Wordpress';

export type ProcessedBlogData = { data: WordpressData; empty: boolean; isBlog: boolean };
export type ProcessedPageData = { data: WordpressData; isPage: boolean };

export const useWordpressDataFormatHelpers = () => {
  const { pathname: url } = useLocation();
  const params = useParams<BlogParams>();

  const processBlogData = useCallback((data: WordpressData): ProcessedBlogData | null => {
    const { day, month, post, year } = params;

    let empty = true;
    const isPostsDataAvailable = data?.posts && data.posts.length > 0;
    let hasPageTitle = false;

    if (isPostsDataAvailable) {
      if ((year || month || day) && (!post)) {
        hasPageTitle = true;
      }

      if (data?.meta?.title) {
        metatitle.formatTitle(url, data.meta.title);
        metatitle.formatDescription(data?.meta?.desc || 'Compare car buyers');
      }

      empty = false;
    }

    return {
      data: isPostsDataAvailable
        ? { ...data, archive: data?.archive?.slice(0, 5) ?? null, hasPageTitle }
        : { ...data, posts: [] },
      empty,
      isBlog: true,
    };
  }, [params, url]);

  const processPageData = useCallback((data: WordpressData): ProcessedPageData | null => {
    if (data?.meta?.title) { // Update meta
      metatitle.formatTitle(url, data.meta.title);
      metatitle.formatDescription(data?.meta?.desc || 'Compare car buyers');
    }

    return {
      data,
      isPage: true,
    };
  }, [url]);

  return { processBlogData, processPageData };
};
